module.exports = __webpack_public_path__ + "static/media/brand07.b8131bfc.png";